import React, { useState } from "react";
import {
  BasePageLayout,
  BaseBox,
  BaseTypography,
  BaseTextField,
  BaseButton,
} from "../../../Common/UI/exports";

function Git() {
  const email = localStorage.getItem("email");

  const [inputData, setInputData] = useState("");
  const [outputData, setOutputData] = useState("");

  const handleAction = async (action) => {
    try {
      let result;

      switch (action) {
        case "delete-branch":
          // TBC
          break;
        default:
          return;
      }

      setOutputData(result);
    } catch (err) {
      console.error(err);
      setOutputData({ error: err.response?.data || err.message });
    }
  };

  return (
    <BasePageLayout sidebarItems={[]}>
      <BaseBox
        sx={{
          height: "calc(100vh - 140px)",
          display: "flex",
          flexDirection: "column",
          maxWidth: "1160px",
          mx: "auto",
          mt: 0,
          px: 2,
        }}
      >
        <BaseTypography sx={{ fontSize: "1.2rem", mb: 0, fontWeight: 600 }}>
          GIT Utilities
        </BaseTypography>

        <BaseBox
          sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}
        >
          <BaseTextField
            label="Input Data"
            placeholder="input data"
            value={inputData}
            onChange={(e) => setInputData(e.target.value)}
            fullWidth
            multiline
            rows={6}
          />

          {/* Buttons */}
          <BaseBox sx={{ display: "flex", gap: 2 }}>
            <BaseButton
              onClick={() => handleAction("delete-branch")}
              color="info"
            >
              Delete Branch
            </BaseButton>
          </BaseBox>

          {/* Output */}
          <BaseTextField
            label="Output"
            value={outputData || ""}
            fullWidth
            multiline
            rows={6}
          />
        </BaseBox>
      </BaseBox>
    </BasePageLayout>
  );
}

export default Git;
